import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import s from "./LinkPayment.module.scss";
import LoginHeader from "../../components/Header/LoginHeader";
import { Col, Form, Row, Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import {
  CreditCardOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { AppDispatch, RootState } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentInfo, getPaymentLink } from "../../redux/BillingSlice";
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import MobileLoginHeader from "../../components/MobileHeader/MobileLoginHeader";

const LinkPayment = () => {
  const [form] = useForm();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const token = useSelector((state: RootState) => state.auth.access);
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  const sendApplicationNumber = async (values: {
    application_number: string;
  }) => {
    if (token) {
      const res = await dispatch(getPaymentInfo(values.application_number));
      if (
        res.type === "billing/getPaymentInfo/fulfilled" &&
        res.payload &&
        "application" in res.payload
      ) {
        setIsError(false);
        navigate(`/payment/${res?.payload?.application?.id}`);
      }
      if (
        res.type === "billing/getPaymentInfo/rejected" &&
        res.payload &&
        "error" in res.payload
      ) {
        setIsError(true);
        setErrorMessage(res.payload.error);
      }
    }

    if (!token) {
      const res = await dispatch(getPaymentLink(values.application_number));

      if (
        res.type === "billing/getPaymentLink/fulfilled" &&
        res.payload &&
        "application" in res.payload
      ) {
        setIsError(false);
        navigate(
          `/payment/link/${res?.payload?.application?.application_number}`
        );
      }

      if (
        res.type === "billing/getPaymentLink/rejected" &&
        res.payload &&
        "error" in res.payload
      ) {
        setIsError(true);
        setErrorMessage(res.payload.error);
      }
    }
  };

  return (
    <div className={s.link_payment}>
      {token ? (
        width > 500 ? (
          <Header />
        ) : (
          <MobileHeader />
        )
      ) : width > 500 ? (
        <LoginHeader />
      ) : (
        <MobileLoginHeader />
      )}

      <div className={s.wrapper}>
        <div className={s.content}>
          <h2 className={s.h2}>
            <CreditCardOutlined className={s.icon} />
            {t("Оплатить заявку")}
          </h2>
          {isError && (
            <Tag className={s.tag} color='orange'>
              <ExclamationCircleOutlined style={{ marginRight: "5px" }} />
              {errorMessage}
            </Tag>
          )}
          <Form
            className={s.form}
            layout='vertical'
            form={form}
            onFinish={sendApplicationNumber}
          >
            <Row
              gutter={24}
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Col>
                <Form.Item
                  className={s.form_item}
                  name='application_number'
                  label={t("Введите номер заявки")}
                  rules={[
                    {
                      required: true,
                      message: t("Введите номер заявки"),
                    },
                    {
                      len: 13,
                      message: t(
                        "Номер заявки должен содержать ровно 13 символов"
                      ),
                    },
                    {
                      pattern: /^\d{13}$/,
                      message: t("Номер заявки должен содержать только цифры"),
                    },
                  ]}
                >
                  <input
                    className={s.input}
                    placeholder={t("Введите номер заявки")}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <button className={s.btn}>{t("Отправить")}</button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LinkPayment;
